import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-image-manager',
  templateUrl: './image-manager.component.html',
  styleUrls: ['./image-manager.component.scss']
})
export class ImageManagerComponent implements OnInit {

  @Input() image:string;
  @Output() imageChange:EventEmitter<string> = new EventEmitter<string>();

  toSave: boolean = false;
  imageChangedEvent: any = '';

  constructor() { }

  ngOnInit() {
  }

  fileChangeEvent(event: any): void {
    this.toSave = true;
    this.imageChangedEvent = event;
}
  imageCropped(image: string) {
      this.image = image;
      console.log(image);
  }
  imageLoaded() {
      // show cropper
  }
  loadImageFailed() {
      // show message
  }

  saveImg() {
    this.toSave = false;
    this.imageChange.emit(this.image);
  }

}



// WEBPACK FOOTER //
// ./src/app/image-manager/image-manager.component.ts